import { render, staticRenderFns } from "./Questionnaire.vue?vue&type=template&id=2144e97b&scoped=true&"
import script from "./Questionnaire.vue?vue&type=script&lang=js&"
export * from "./Questionnaire.vue?vue&type=script&lang=js&"
import style0 from "./Questionnaire.vue?vue&type=style&index=0&id=2144e97b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2144e97b",
  null
  
)

export default component.exports